export const el = {
  welcome: 'Καλώς ήρθατε',
  logout: 'Αποσύνδεση',
  settings: 'Ρυθμίσεις',

  days: ['Κυριακή', 'Δευτέρα', 'Τρίτη', 'Τετάρτη', 'Πέμπτη', 'Παρασκευή', 'Σάββατο'],
  today: 'Σήμερα',
  yesterday: 'Χθες',

  THEME: {
    DARK: 'Σκούρο',
    LIGHT: 'Ανοιχτό',
  },

  PLACEHOLDER: {
    SEARCH_PLACEHOLDER: 'Αναζήτηση...',
    SELECT_OPTION: 'Επιλέξτε μια επιλογή...',
    SELECT_STATUS: 'Επιλέξτε κατάσταση...',
    CHOOSE_STATUS: 'Επιλέξτε κατάσταση...',
    LOCATION: 'Εισαγάγετε πόλη, διεύθυνση ή τοποθεσία...',
    DESCRIPTION: 'Περιγραφή του συμβάντος',
    AI_DESCRIPTION:
      'Περιγράψτε τι συνέβη, πού και πότε — π.χ. Ξέσπασε μικρή πυρκαγιά στο ηλεκτρικό δωμάτιο κοντά στην οδό Balestier, Novena.',
    LOCATION_DESCRIPTION: 'Πρόσθετες λεπτομέρειες για την τοποθεσία',
    VALIDATING: 'Επικύρωση...',
    GENERATING: 'Δημιουργία...',
  },

  CHAT_PANEL: {
    SEARCH_PLACEHOLDER: 'Αναζήτηση...',
    NO_MESSAGES_YET: 'Δεν υπάρχουν μηνύματα ακόμα',
    IS_SPEAKING: 'μιλάει...',
    ONLINE: 'συνδεδεμένος',
    OFFLINE: 'εκτός σύνδεσης',
    TRANSCRIBING: 'Μεταγραφή...',
    NO_CHAT_FOUND: 'Δεν βρέθηκαν συνομιλίες',
    NO_CHAT_SELECTED_TITLE: 'Δεν επιλέχθηκε συνομιλία',
    NO_CHAT_SELECTED_DESCRIPTION:
      'Επιλέξτε έναν χρήστη ή μια ομάδα από το πλαϊνό μενού για να ξεκινήσετε την ανταλλαγή μηνυμάτων',
    INPUT_PLACEHOLDER_DEFAULT: 'Γράψτε ένα μήνυμα...',
    INPUT_PLACEHOLDER_WITH_ATTACHMENT: 'Προσθέστε λεζάντα...',
    IS_TALKING: 'μιλάει...',
    PTT_ACTIVE: 'PTT Ενεργό – Ομιλία...',
    PTT_LOCKED: 'PTT Κλειδωμένο – Κάντε κλικ για απελευθέρωση',
    PTT_SLIDE_HINT: 'Σύρετε προς τα πάνω για να κλειδώσετε',
    PTT_RELEASE_AND_SEND: 'Απελευθέρωση & Αποστολή',
    ATTACHED_FILES_TITLE: 'Συννημένα αρχεία',
    FAILED_TO_TRANSCRIBE_AUDIO: 'Αποτυχία μεταγραφής ήχου',
    NO_CHAT_MESSAGE: 'Δεν υπάρχει μήνυμα συνομιλίας',
    FALLBACK_MESSAGE:
      'Για να ξεκινήσετε μια συνομιλία, πληκτρολογήστε το μήνυμά σας ή χρησιμοποιήστε τη λειτουργία PTT/PTV.',
    INCOMING_VIDEO_CALL: 'Εισερχόμενη κλήση PTV...',
    SOMETHING_WENT_WRONG: 'Κάτι πήγε στραβά',
    ERROR: 'Σφάλμα:',
    NO_MESSAGES_FOUND_FOR: 'Δεν βρέθηκαν μηνύματα για',
    SYSTEM_MESSAGE: 'Μήνυμα συστήματος',
    GROUP: 'ομάδα',
    AUDIO: 'ήχος',
    VIDEO: 'βίντεο',
    FILE: 'αρχείο',
    ME: 'εγώ',
    IMAGE: 'εικόνα',
    TEXT: 'κείμενο',
    CHAT: 'συνομιλία',
    NONE: 'κανένα',
    PROFILE: 'προφίλ',
    SEARCH: 'αναζήτηση',
    COMPLETED: 'ολοκληρώθηκε',
    RESOLVED: 'επιλυμένο',
    USER_EMAIL_DOMAIN: '@widebridgecloud.com',
    UNKNOWN: 'Άγνωστο',
    THEM: 'αυτοί',
    HAS_ACCEPTED_THE_INCIDENT: 'har godtatt hendelsen',
    INCIDENT_HAS_BEEN_UPDATED: 'Hendelsen har blitt oppdatert',
    INCIDENT_HAS_BEEN_RESOLVED: 'Hendelsen har blitt løst',
    YOU_HAVE_JOINED_THE_GROUP: 'Du har blitt med i gruppen',
  },

  PROFILE_PANEL: {
    MEMBERS_LABEL: 'μέλη',
    GROUP_MEMBERS_TITLE: 'Μέλη Ομάδας',
    USERNAME_LABEL: 'Όνομα χρήστη',
    EMAIL_LABEL: 'Email',
    MEMBER_FALLBACK_NAME: 'Μέλος',
    MEMBER_FALLBACK_ID: 'Μέλος',
  },

  PTT: {
    AUDIO: {
      FILENAME_PREFIX: 'ptt-audio-',
      FILE_TYPE: 'audio/webm',
      FILE_EXTENSION: '.webm',
    },
    MESSAGES: {
      START_RECORDING: 'Η εγγραφή PTT ξεκίνησε για {{userName}}',
      STOP_RECORDING: 'Το PTT audio στάλθηκε σε {{userName}}',
      NO_AUDIO_DATA: 'Δεν λήφθηκαν δεδομένα ήχου από το SDK',
      TRANSCRIPTION_SUCCESS: 'Η μεταγραφή ήχου ολοκληρώθηκε',
      TRANSCRIPTION_FAILED: 'Η μεταγραφή απέτυχε, αποστολή ήχου χωρίς κείμενο',
    },
    TRANSCRIPTION: {
      MODEL: 'whisper-1',
      LANGUAGE: 'el',
      RESPONSE_FORMAT: 'text',
    },
  },

  CHAT_WINDOW: {
    SEARCH_IN: 'Αναζήτηση σε',
    YOUR_PROFILE: 'Το προφίλ σου',
    VIEW_PROFILE: 'Προβολή προφίλ',
    PIN_CHAT: 'Καρφίτσωμα συνομιλίας',
    UNPIN_CHAT: 'Ξεκαρφίτσωμα συνομιλίας',
    MUTE_CHAT: 'Σίγαση συνομιλίας',
    UNMUTE_CHAT: 'Άρση σίγασης συνομιλίας',
  },

  DASHBOARD: {
    INCIDENTS: 'συμβάντα',
    INCIDENTS_NO_DATA: 'Για να δημιουργήσετε ένα συμβάν, κάντε κλικ στο κουμπί "+ Δημιουργία συμβάντος"',
    RESPONDERS: 'ανταποκριτές',
    RESPONDERS_NO_DATA: 'Δεν βρέθηκαν ανταποκριτές.',
    CHAT: 'συνομιλία',
    ALERTS: 'ειδοποιήσεις',
    ALERTS_NO_DATA: 'Δεν δημιουργήθηκαν ειδοποιήσεις από το σύστημα.',
    UPDATES: 'ενημερώσεις',
    UPDATES_NO_DATA: 'Δεν υπάρχουν ενημερώσεις για το συμβάν ή τους ανταποκριτές.',
    NEW_MESSAGE_FROM: 'Νέο μήνυμα από',
    INCIDENT_UPDATED_BY: 'Το συμβάν ενημερώθηκε από',
    NEW_INCIDENT_CREATED_BY: 'Δημιουργήθηκε νέο συμβάν από',
    PROFILE: 'προφίλ',
    SUMMARY: 'περίληψη',
    GENERATING_SUMMARY: 'δημιουργία περίληψης...',
  },

  INCIDENTS_PANEL: {
    INCIDENT_NAME: 'Όνομα περιστατικού',
    INCIDENT_TYPE: 'Τύπος περιστατικού',
    ASSIGNEES: 'ανατεθειμένοι',
    SEVERITY: 'σοβαρότητα',
    STATUS: 'κατάσταση',
    STATUS_HISTORY: 'Ιστορικό κατάστασης',
    SHOW: 'Εμφάνιση',
    SHOW_LESS: 'Εμφάνιση λιγότερων',
    MORE: 'περισσότερα',
    PTT: 'PTT',
    LOCATION: 'τοποθεσία',
    SEVERITY_CRITICAL: 'κρίσιμο',
    SEVERITY_HIGH: 'υψηλό',
    SEVERITY_MEDIUM: 'μεσαίο',
    SEVERITY_LOW: 'χαμηλό',
    SEVERITY_MINIMAL: 'ελάχιστο',
    REPORTED_DATE_TIME: 'Αναφερόμενη ημερομηνία και ώρα',
    REPORTED_NAME: 'Όνομα αναφέροντος',
    DESCRIPTION: 'περιγραφή',
    RESPONDERS: 'ανταποκριτές',
    ATTACHMENTS: 'συνημμένα',
    LOCATION_DESCRIPTION: 'περιγραφή τοποθεσίας',
    NO_RESPONDERS_ASSIGNED: 'Δεν έχουν ανατεθεί ανταποκριτές στο περιστατικό.',
    CREATE_INCIDENT: 'Δημιουργία περιστατικού',
    EDIT_INCIDENT: 'Επεξεργασία περιστατικού',
    SELECT_RESPONDERS: 'Επιλογή ανταποκριτών',
    COMPLETE: 'Ολοκλήρωση',
    CANCEL: 'Ακύρωση',
    SAVE: 'Αποθήκευση αλλαγών',
    NO: 'Όχι',
    DATA_FOUND: 'Βρέθηκαν δεδομένα',
    NO_OPTIONS: 'Δεν υπάρχουν διαθέσιμες επιλογές',
    AI_ASSISTANCE: 'Βοήθεια ΤΝ',
  },
  TAB_KEYS: {
    ALL: 'όλα',
    UNREAD: 'μη αναγνωσμένο',
    ACTIVE: 'ενεργό',
    CLOSED: 'κλειστό',
    AVAILABLE: 'διαθέσιμο',
    OFFLINE: 'εκτός σύνδεσης',
    TAB_VALUE_UNACKNOWLEDGED: 'μη επιβεβαιωμένο',
    TAB_VALUE_CREATED: 'δημιουργήθηκε',
    TAB_VALUE_PROGRESS: 'σε εξέλιξη',
    TAB_VALUE_RESOLVED: 'επιλύθηκε',
  },

  UPDATES_PANEL: {
    UPDATES: 'Ενημερώσεις',
    MARK_AS_READ: 'Επισήμανση όλων ως αναγνωσμένα',
    ALL: 'Όλα',
    UNREAD: 'Μη αναγνωσμένα',
    ALL_KEY: 'all',
    UNREAD_KEY: 'unread',
    NO_NOTIFICATIONS: 'Δεν υπάρχουν ειδοποιήσεις',
    NO_UNREAD_NOTIFICATIONS: 'Δεν υπάρχουν μη αναγνωσμένες ειδοποιήσεις',
    UPDATE_STATUS: 'Ενημέρωση κατάστασης:',

    // Notification titles
    NEW_INCIDENT_TITLE: 'Νέο Συμβάν',
    UPDATE_TITLE: 'Ενημέρωση',

    CREATED_AT: 'δημιουργήθηκε στις',

    // Status labels
    STATUS_CLOSED: 'Κλειστό',
    STATUS_IN_PROGRESS: 'Σε Εξέλιξη',

    // Change descriptions
    STATUS_CHANGE: 'Κατάσταση',
    SEVERITY_CHANGE: 'Σοβαρότητα',
    TYPE_CHANGE: 'Τύπος',
    DESCRIPTION_UPDATED: 'Η περιγραφή ενημερώθηκε',
    RESPONDERS_ADDED: 'διασώστης/διασώστες προστέθηκαν',
    RESPONDERS_REMOVED: 'διασώστης/διασώστες αφαιρέθηκαν',
    RESPONDERS_UPDATED: 'Οι διασώστες ενημερώθηκαν',
    LOCATION_CHANGED: 'Η τοποθεσία άλλαξε',
    UPDATED_DEFAULT: 'Ενημερώθηκε',

    //Time
    UNKNOWN: 'Άγνωστο',
    JUST_NOW: 'μόλις τώρα',
    MINUTES_AGO: 'πριν από {{count}} λεπτό',
    MINUTES_AGO_plural: 'πριν από {{count}} λεπτά',
    HOURS_AGO: 'πριν από {{count}} ώρα',
    HOURS_AGO_plural: 'πριν από {{count}} ώρες',
    DAYS_AGO: 'πριν από {{count}} ημέρα',
    DAYS_AGO_plural: 'πριν από {{count}} ημέρες',

    // Default values
    DEFAULT_TYPE: 'Συμβάν',
    UNKNOWN_LOCATION: 'Άγνωστη τοποθεσία',
  },

  MAP_VIEW: {
    INCIDENT_TOOLTIP: {
      INCIDENTTYPE: 'Τύπος Περιστατικού',
      REPORTEDDATE: 'Ημερομηνία Αναφοράς',
      SEVERITY: 'Σοβαρότητα',
      STATUS: 'Κατάσταση',
      RESPONDERS: 'Ανταποκριτές',
      NO_RESPONDERS: 'Δεν υπάρχουν διαθέσιμοι ανταποκριτές',
    },
    INCIDENT_CLUSTER_TOOLTIP: {
      INCIDENTS: 'Περιστατικά',
      MORE: 'περισσότερα...',
    },
    MAP_FILTER: {
      VIEW_MODE: 'Λειτουργία προβολής',
      DEFAULT: 'Προεπιλογή',
      SATELLITE: 'Δορυφορική',
      FILTER_BY: 'Φιλτράρισμα κατά',
      ALL: 'όλα',
      ACTIVE: 'Ενεργά',
      COMPLETED: 'Ολοκληρωμένα',
      RESPONDERS: 'Ανταποκριτές',
      AVAILABLE: 'διαθέσιμο',
    },
  },

  FALLBACK_SCREEN: {
    NO: 'Όχι',
    DATA_FOUND: 'Βρέθηκαν Δεδομένα',
    CREATE_INCIDENT: 'Δημιουργία Περιστατικού',
    NO_AVAILABLE_RESPONDER_FOUND: 'Δεν βρέθηκε διαθέσιμος ανταποκριτής',
  },

  PERMISSION_DIALOG: {
    MICROPHONE: {
      TITLE: 'Απαιτείται πρόσβαση στο μικρόφωνο',
      DESCRIPTION: 'Αυτή η εφαρμογή χρειάζεται πρόσβαση στο μικρόφωνό σας για να λειτουργήσει σωστά.',
      INSTRUCTION: 'Παρακαλώ επιτρέψτε την πρόσβαση στο μικρόφωνο για να συνεχίσετε να χρησιμοποιείτε την εφαρμογή.',
      BUTTON_LABEL: 'Επιτρέψτε πρόσβαση στο μικρόφωνο',
    },
    CAMERA: {
      TITLE: 'Απαιτείται πρόσβαση στην κάμερα',
      DESCRIPTION: 'Αυτή η εφαρμογή χρειάζεται πρόσβαση στην κάμερά σας για να λειτουργήσει σωστά.',
      INSTRUCTION: 'Παρακαλώ επιτρέψτε την πρόσβαση στην κάμερα για να συνεχίσετε να χρησιμοποιείτε την εφαρμογή.',
      BUTTON_LABEL: 'Επιτρέψτε πρόσβαση στην κάμερα',
    },
    NOTIFICATIONS: {
      TITLE: 'Απαιτείται άδεια ειδοποιήσεων',
      DESCRIPTION: 'Αυτή η εφαρμογή χρειάζεται άδεια για να σας στέλνει ειδοποιήσεις.',
      INSTRUCTION: 'Παρακαλώ επιτρέψτε ειδοποιήσεις για να συνεχίσετε να χρησιμοποιείτε την εφαρμογή.',
      BUTTON_LABEL: 'Επιτρέψτε ειδοποιήσεις',
    },
    GEOLOCATION: {
      TITLE: 'Απαιτείται πρόσβαση τοποθεσίας',
      DESCRIPTION: 'Αυτή η εφαρμογή χρειάζεται πρόσβαση στην τοποθεσία σας για να λειτουργήσει σωστά.',
      INSTRUCTION: 'Παρακαλώ επιτρέψτε πρόσβαση στην τοποθεσία για να συνεχίσετε να χρησιμοποιείτε την εφαρμογή.',
      BUTTON_LABEL: 'Επιτρέψτε πρόσβαση στην τοποθεσία',
    },
    HEADINGS: {
      WHAT_TO_DO: 'Τι πρέπει να κάνετε:',
      ADDITIONAL_REQUIRED: 'Απαιτούνται επιπλέον άδειες',
      GENERIC_PERMISSION_TITLE: 'Απαιτείται άδεια',
      GENERIC_DESCRIPTION: 'Αυτή η εφαρμογή χρειάζεται επιπλέον άδειες για να λειτουργήσει σωστά.',
      GENERIC_INSTRUCTION: 'Παρακαλώ επιτρέψτε τις απαιτούμενες άδειες για να συνεχίσετε.',
    },
    DEFAULT_BUTTON_LABEL: 'Επιτρέψτε άδεια',
  },
  SETTINGS: {
    TITLE: 'Ρυθμίσεις',
    SUBTITLE: 'Διαχείριση προτιμήσεων γλώσσας και μετάφρασης',
    LANGUAGE_DISPLAY: 'Γλώσσα εμφάνισης',
    AUTO_TRANSLATE_TITLE: 'Ενεργοποίηση αυτόματης μετάφρασης',
    AUTO_TRANSLATE_DESCRIPTION: 'Μετάφραση εισερχόμενων μηνυμάτων αυτόματα στη γλώσσα που επιλέξατε.',
    SAVE_BUTTON: 'Αποθήκευση',
    SELECT_PLACEHOLDER: 'Επιλέξτε μια επιλογή...',
  },
  SOS_MODAL: {
    TITLE_ALERT_TRIGGERED: 'Ενεργοποιήθηκε ειδοποίηση SOS',
    LOCATION_LABEL: 'Τοποθεσία',
    INCIDENT_LABEL: 'Περιστατικό',
    LAST_STATUS_LABEL: 'Τελευταία κατάσταση',
    ASSIST_BUTTON: 'Βοήθεια',
  },
  HEADER: {
    USERNAME: 'Όνομα χρήστη',
    MODE: 'Λειτουργία',
    SETTINGS: 'Ρυθμίσεις',
    LOG_OUT: 'Αποσύνδεση',
    TITLE: 'AGIL Field Ops',
  },

  ERRORS: {
    INVALID_CHAT_DATA: 'Μη έγκυρα δεδομένα συνομιλίας',
    SUMMARY_GENERATION_FAILED: 'Αποτυχία δημιουργίας περίληψης:',
    FAILED_TO_GENERATE_SUMMARY: 'Αποτυχία δημιουργίας περίληψης.',
    PLEASE_TRY_AGAIN: 'Παρακαλώ δοκιμάστε ξανά.',
    UNKNOWN: 'Άγνωστο',
    IN_PROGRESS_STATUS_ERROR: 'Πρέπει να ανατεθεί τουλάχιστον ένας ανταποκριτής όταν η κατάσταση είναι "Σε εξέλιξη"',
    RESOLVED_STATUS_ERROR: 'Πρέπει να ανατεθεί τουλάχιστον ένας ανταποκριτής πριν κλείσει το περιστατικό',
    SELECT_ONE_RESPONDER_ERROR: 'Παρακαλώ επιλέξτε τουλάχιστον έναν ανταποκριτή',
    WAIT_BEFORE_SUBMIT_AGAIN: 'Παρακαλώ περιμένετε πριν υποβάλετε ξανά',
    INCIDENT_CREATION_SERVICE_UNAVAILABLE:
      'Η υπηρεσία δημιουργίας περιστατικών δεν είναι διαθέσιμη. Παρακαλώ δοκιμάστε αργότερα.',
    NO_CHANGES_TO_UPDATE: 'Δεν υπάρχουν αλλαγές για ενημέρωση',
    FAILED_TO_UPDATE_INCIDENT: 'Αποτυχία ενημέρωσης περιστατικού. Ελέγξτε τη σύνδεσή σας και δοκιμάστε ξανά.',
    FAILED_TO_CREATE_INCIDENT: 'Αποτυχία δημιουργίας περιστατικού. Ελέγξτε τη σύνδεσή σας και δοκιμάστε ξανά.',
  },

  INCIDENT_TYPES: [
    { value: 'Medical', label: 'Ιατρικό' },
    { value: 'Car accident', label: 'Τροχαίο ατύχημα' },
    { value: 'Fire', label: 'Φωτιά' },
    { value: 'Patrol', label: 'Περίπολος' },
  ],

  SEVERITY_VALUES: [
    { value: 4, label: 'Κρίσιμο', dotColor: 'bg-icon-error' },
    { value: 3, label: 'Υψηλό', dotColor: 'bg-chart-2' },
    { value: 2, label: 'Μέτριο', dotColor: 'bg-chart-4' },
    { value: 1, label: 'Χαμηλό', dotColor: 'bg-interactive' },
    { value: 0, label: 'Ελάχιστο', dotColor: 'bg-icon-muted' },
  ],

  INCIDENT_CARD_STATUS_VALUES: [
    { value: 'created', label: 'Δημιουργήθηκε' },
    { value: 'progress', label: 'Σε εξέλιξη' },
    { value: 'resolved', label: 'Επιλύθηκε' },
  ],

  CREATE_INCIDENT_STATUS_VALUES: [
    { value: 'open', label: 'Δημιουργήθηκε' },
    { value: 'in_progress', label: 'Σε εξέλιξη', disabled: false },
  ],

  EDIT_INCIDENT_STATUS_VALUES: [
    { value: 'in_progress', label: 'Σε εξέλιξη' },
    { value: 'resolved', label: 'Κλειστό' },
  ],

  INCIDENT_DETAILS_STATUS_VALUES: [
    { value: 'created', label: 'Δημιουργήθηκε', disabled: true },
    { value: 'progress', label: 'Σε εξέλιξη', disabled: true },
    { value: 'resolved', label: 'Κλειστό', disabled: true },
  ],

  RESPONSE_STATUS: [
    { value: 'accepted', label: 'Αποδεκτό' },
    { value: 'rejected', label: 'Απορρίφθηκε' },
    { value: 'pending', label: 'Εκκρεμεί' },
  ],

  ASSIGNEE_STATUS: [
    { value: 'not_started', label: 'Δεν ξεκίνησε' },
    { value: 'on_the_way', label: 'Καθοδόν' },
    { value: 'reach_site', label: 'Έφτασε στο σημείο' },
    { value: 'enroute', label: 'Καθοδόν' },
    { value: 'done', label: 'Ολοκληρώθηκε' },
  ],

  RESPONDER_STATUS: [
    { value: 'Unacknowledged', label: 'Μη επιβεβαιωμένο' },
    { value: 'Rejected', label: 'Απορρίφθηκε' },
    { value: 'Arrived at scene', label: 'Έφτασε στη σκηνή' },
    { value: 'On the way', label: 'Καθ’ οδόν' },
    { value: 'Aborted', label: 'Ακυρώθηκε' },
    { value: 'Done', label: 'Ολοκληρώθηκε' },
  ],

  WEEKDAYS: [
    { value: 'Sun', label: 'Κυρ' },
    { value: 'Mon', label: 'Δευ' },
    { value: 'Tue', label: 'Τρι' },
    { value: 'Wed', label: 'Τετ' },
    { value: 'Thu', label: 'Πεμ' },
    { value: 'Fri', label: 'Παρ' },
    { value: 'Sat', label: 'Σαβ' },
  ],
};
